import { atom } from "jotai";

export const accessTokensAtom = atom<Record<string, Promise<string>>>({});
